/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');
require('../plugins');

window.Vue = require('vue');
window.Vue.config.productionTip = false;

require('bootstrap4-toggle');
import { BootstrapVue} from 'bootstrap-vue'
Vue.use(BootstrapVue)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);

import moment from 'moment'
if (window.language == "en") {
} else
    require('moment/locale/de')
Vue.prototype.moment = moment

import VCalendar from 'v-calendar';
Vue.use(VCalendar, {
    componentPrefix: 'vc',
});

import _ from 'lodash'
Vue.prototype.__ = (str, args) => {
    let returnValue = _.get(window.i18n, str) || str;
    for (const key in args) {
        if (Object.hasOwnProperty.call(args, key)) {
            const element = args[key];
            returnValue = returnValue.replace(":"+key, element);
        }
    }
    return returnValue;
}

window.__ = (str, args) => {
    let returnValue = _.get(window.i18n, str) || str;
    for (const key in args) {
        if (Object.hasOwnProperty.call(args, key)) {
            const element = args[key];
            returnValue = returnValue.replace(":"+key, element);
        }
    }
    return returnValue;
}

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.events = new Vue();

window.toastSuccess = function(title, body) {
    window.events.$emit('toast-success', title, body);
};

window.toastError = function(title, body) {
    window.events.$emit('toast-error', title, body);
};

const app = new Vue({
    el: '#app',
});
